export const INBOX_DETAILS_MESSAGES = {
  INVALID_REQUEST_LINK: "Invalid request link or encryption key mismatch.",
  FETCH_REQUEST_DETAILS_FAILED: "Failed to fetch request details.",
  LOAD_REQUEST_DETAILS_FAILED: "Failed to load request details.",
  UPDATE_APPROVAL_FAILED: "Failed to update approval",
  UPDATE_BOOKING_DETAILS_FIRST: "Before approving the request, please update booking details.",
  REJECT_REMARKS_REQUIRED: "Before rejecting the request, please enter mandatory remarks.",
  PAYMENT_REJECT_REMARKS_REQUIRED: "Before rejecting payment, please enter mandatory remarks.",
  PAYMENT_APPROVAL_FAILED: "Failed to approve payment.",
  PAYMENT_REJECTION_FAILED: "Failed to reject payment.",
};
